import * as React from 'react';
import { observer } from 'mobx-react';

const StyleTag: React.FC<{ css: string; type?: string }> = ({ css, type }) => (
    <style data-type={type || ''}>{`${css}`}</style>
);

export default observer(StyleTag);
